import React, { useState } from "react";
import ReactDom from "react-dom";
import "../styles/Projects.css";
import { projects } from "../details/data";
import CloseIcon from "@mui/icons-material/Close";

function FilterBar({ category, last, first, name, color }) {
  return (
    <div
      className="category"
      style={
        first
          ? { borderRadius: "10px 0px 0px 10px", backgroundColor: color }
          : last
          ? { borderRadius: "0px 10px 10px 0px", backgroundColor: color }
          : { borderRadius: "0px", backgroundColor: color }
      }
      onClick={() => name(category)}
    >
      {category.toUpperCase()}
    </div>
  );
}

function TagTile({ tag, big }) {
  return (
    <div
      className="tagStyle"
      style={big ? { fontSize: "14px" } : { fontSize: "12px" }}
    >
      <p>{tag}</p>
    </div>
  );
}

function ProjectTile({ title, date, desc, image, tags, github, live = "" }) {
  const [show, setShow] = useState(false);
  if (show) {
    document.body.style.overflow = "hidden";
    return ReactDom.createPortal(
      <>
        <div className="modalOverlay" onClick={() => setShow(!show)}></div>
        <div className="bigProjectCard">
          <div className="bigProjectCancel">
            <CloseIcon onClick={() => setShow(!show)} />
          </div>
          <img className="bigProjectImage" src={image} alt={title} />
          <div className="bigProjectTags">
            {tags.map((tag, index) => (
              <TagTile tag={tag} key={index} big={show} />
            ))}
          </div>
          <div className="bigProjectTitle">
            <h1>{title}</h1>
            <p>{date}</p>
          </div>
          <div className="bigProjectDescription">
            <p>{desc}</p>
          </div>
          <div className="bigProjectFooter">
            {github ? (
              <a
                href={github}
                target="_blank"
                rel="noreferrer"
                className="viewCode"
              >
                View Code
              </a>
            ) : (
              <div></div>
            )}
            {live ? (
              <a
                href={live}
                target="_blank"
                rel="noreferrer"
                className="viewApp"
              >
                View Live App
              </a>
            ) : (
              <div> </div>
            )}
          </div>
        </div>
      </>,
      document.getElementById("portal")
    );
  } else {
    document.body.style.overflow = "auto";
    return (
      <>
        <div className="projectCard" onClick={() => setShow(!show)}>
          <img className="projectImage" src={image} alt={title} />
          <div className="projectTags">
            {tags.map((tag, index) => (
              <TagTile tag={tag} key={index} big={show} />
            ))}
          </div>
          <div className="projectTitle">
            <h1>{title}</h1>
            <p>{date}</p>
          </div>
          <div className="projectDescription">
            <p>{desc}</p>
          </div>
        </div>
      </>
    );
  }
}

function Projects() {
  const [name, setName] = useState("All");
  function filterProjects(project) {
    return project.category === name;
  }
  return (
    <section id="projects" className="projects">
      <h1 className="projectName">Projects</h1>
      <p className="projectDesc">
        I worked on a wide range of projects. From Web Apps to Flutter apps.
        Here are some of my Projects with their tech stack and description.
      </p>
      <div className="filterBar">
        {projects
          .reduce(
            (categories, project) => {
              if (!categories.includes(project.category)) {
                categories.push(project.category);
              }
              return categories;
            },
            ["All"]
          )
          .map((category, index, array) => (
            <FilterBar
              category={category}
              last={index === array.length - 1}
              first={index === 0}
              name={setName}
              key={index}
              color={
                name === category ? "rgba(133, 76, 230, 0.3)" : "transparent"
              }
            />
          ))}
      </div>
      <div className="projectTile">
        {name === "All"
          ? projects.map((p) => (
              <ProjectTile
                title={p.title}
                date={p.date}
                desc={p.description}
                image={p.image}
                github={p.github}
                live={p.webapp}
                tags={p.tags}
                key={p.id}
              />
            ))
          : projects
              .filter(filterProjects)
              .map((p) => (
                <ProjectTile
                  title={p.title}
                  date={p.date}
                  desc={p.description}
                  image={p.image}
                  github={p.github}
                  live={p.webapp}
                  tags={p.tags}
                  key={p.id}
                />
              ))}
      </div>
    </section>
  );
}

export default Projects;
